/* ==========================================================================
   PanelAccommodation > Rooms
   ========================================================================== */

/* Modules */
const CounterClient = require('@bluekiri/alexandria-contrib-components/components/counter/client/js');
const SelectClient = require('@bluekiri/alexandria-contrib-components/components/select/client/js/index');
const config = require('./config');

const events = {
    bindEvents: function Fn() {
        this.onClickRemove = this.onClickRemove.bind(this);
    },
    addEventListener: function Fn(instance, room) {
        const removeBtn = room.querySelector(config().removeRoom.selector);

        this.bindEvents();

        this.instance = instance;

        removeBtn.addEventListener('click', this.onClickRemove);

        return this;
    },
    removeEventListener: function Fn(element) {
        element.removeEventListener('click', this.onClickRemove);
        return this;
    },
    onClickRemove: function Fn(event) {
        const room = event.target.parentNode.parentElement;
        const roomId = room.dataset.id;

        removeRoom(this.instance, room, roomId);
    },
    onChangeAdults: function Fn(instance, roomId) {
        const result = instance;

        if (result.counters.adults.length <= result.counters.adults.max) {
            if (result.rooms.length === 1) {
                result.counters.adults.length = result.roomStore[roomId].adults.get();
            } else {
                updateCounter(result, roomId, 'adults');
            }

            // set codeHas of room
            setCodeHash(result, 'adults');

            // Set info on input trigger
            set(result);
        }
    },
    onChangeChildren: function Fn(instance, roomId) {
        const result = instance;

        if (instance.counters.children.length <= instance.counters.children.max) {
            if (instance.rooms.length === 1) {
                result.counters.children.length = instance.roomStore[roomId].children.get();
            } else {
                updateCounter(result, roomId, 'children');
            }
        }

        /* Ages */
        onChangeChildrenHandleAges(instance, roomId);

        // set codeHas of room
        setCodeHash(instance, 'children');

        // Set info on input trigger
        set(instance);
    },
    onChangeAges: function Fn(instance) {
        setCodeHash(instance, 'children');
    }
};

function onChangeChildrenHandleAgesLesserCurrent(instance, roomId, currentAge) {
    const ref = instance;
    const select = instance.roomStore[roomId].ages[currentAge - 1].element;
    ref.roomStore[roomId].current--;

    setHide(select);
}

function onChangeChildrenHandleAgesGreaterCurrent(instance, roomId, currentAge) {
    const ref = instance;
    const select = instance.roomStore[roomId].ages[currentAge].element;
    ref.roomStore[roomId].current++;

    setVisible(select);
}

function onChangeChildrenHandleAgesZero(instance, roomId, ages) {
    const ref = instance;
    const select = instance.roomStore[roomId].ages[0].element;
    ref.roomStore[roomId].current--;

    setHide(select);
    setHide(ages);
}

function onChangeChildrenHandleAges(instance, roomId) {
    const ages = document.querySelector(config().getSelectorById(instance, 'ages', roomId));
    const ageValue = instance.roomStore[roomId].children.get();

    // show ages container
    const currentAge = instance.roomStore[roomId].current;

    setVisible(ages);

    // show / hide select group of ages and age select
    if (ageValue === 0 && currentAge === 1) {
        onChangeChildrenHandleAgesZero(instance, roomId, ages);
    } else if (ageValue > currentAge) {
        if (ageValue === 1 && currentAge === 0) {
            setVisible(ages);
        }

        onChangeChildrenHandleAgesGreaterCurrent(instance, roomId, currentAge);
    } else if (ageValue < currentAge) {
        onChangeChildrenHandleAgesLesserCurrent(instance, roomId, currentAge);
    }
}

/**
 * set: print the info of the panel in a input
 * @param {object} instance instace of the panel
 * @returns void
 */
function set(instance) {
    const result = instance;

    result.infoRooms = buildInfo(result);

    if (instance.config.triggerInput) instance.config.triggerInput.set(result.infoRooms);
}

/**
 * setVisible: show a element, delete class hidden
 * @param [HTMLElement] element: HTMLElement to show
 * @returns void
 */
function setVisible(element) {
    element.classList.remove(config().helperStyles.hidden);
}

/**
 * setHide: hide a element, add class hidden
 * @param [HTMLElement] element: HTMLElement to hide
 * @returns void
 */
function setHide(element) {
    element.classList.add(config().helperStyles.hidden);
}

/**
 * setCounter: save on the panel instace the default configuration of a counters
 * @param {object} instance instace of the panel
 * @param [HTMLElement] element: HTMLElement to hide
 * @param String variable: name of the variable to save in the panel instance
 * @returns void
 */
function setCounter(instance, element, variable) {
    const result = instance;

    result.counters[variable] = {
        max: parseInt(element.dataset.max, 10),
        min: parseInt(element.dataset.min, 10),
        value: parseInt(element.dataset.default, 10)
    };
}

/**
 * setCodeHashAdult: save in the instance.roomStore the hashCode of the all adults and children for each room
 * @param {Object} instance instace of the panel
 * @param {String} type type of code to build(adults, children...)
 * @returns void
 */
function setCodeHash(instance, type) {
    const result = instance;
    const defaultAge = `defaultAge-${type}`.replace(/-([a-z])/g, g => g[1].toUpperCase());
    const roomCode = `code-${type}`.replace(/-([a-z])/g, g => g[1].toUpperCase());

    [...Object.values(result.roomStore)].forEach(item => {
        const room = item;
        const ages = result.roomStore[room.roomID].ages || false;
        let codeHash = '';

        for (let i = 0; i < item[type].get(); i++) {
            const age = config().room[defaultAge] === false ? ages[i].get().value : config().room[defaultAge];
            codeHash += `${age}${config().room[roomCode]}`;
        }

        room.codeHash[type] = codeHash;
    });
}

/**
 * get: return info of the panel, adults, children, rooms and discounts
 * @param {Object} instance instace of the panel
 * @param {String} type type of code to build(adults, children...)
 * @returns {String} Info of the panel // result.infoPanel
 */
function get(instance) {
    return buildInfo(instance);
}

/**
 * buildInfo: buid info of the panel, adults, children, rooms and discounts
 * @param {object} instance Object: instace of the panel
 * @returns {string} Info of the panel // result.infoPanel
 */
function buildInfo(instance) {
    const result = instance;
    const adults = instance.counters.adults.length;
    const children = instance.counters.children.length;
    const roomsAmount = instance.rooms.length;
    const adultsLiteral = adults > 1 ? instance.literals.adults : instance.literals.adult;
    const childrenLiteral = children > 1 || children !== 1 ? instance.literals.children : instance.literals.kid;
    const roomLiteral = roomsAmount > 1 || roomsAmount === 0 ? instance.literals.rooms : instance.literals.room;
    const childrenInfo = children > 0 ? `${children} ${childrenLiteral}, ` : '';

    const infoRooms = `${adults} ${adultsLiteral}, ${childrenInfo} ${roomsAmount} ${roomLiteral}`;

    result.infoRooms = infoRooms;

    const info = result.infoDiscount ? `${infoRooms} ${result.infoDiscount}` : infoRooms;

    result.infoPanel = info;

    return result.infoPanel;
}

/**
 * getHashRooms: return a string with all hash codes
 * @param {Object} instance instace of the panel
 * @returns {String}
 */
function getHashRooms(instance) {
    let hashRooms = '';

    [...Object.values(instance.roomStore)].forEach((item, i) => {
        if (i !== 0) hashRooms += ',';
        hashRooms += `${item.codeHash.adults}${item.codeHash.children}`;
    });

    return hashRooms;
}

/**
 * calculateCounterLength: calculate how many adults or children has been selected
 * @param {Object} instance instace of the panel
 * @param {String} counter the name of counter (adults, children)
 * @returns {String} result.counters['counter'].length
 */
function calculateCounterLength(instance, counter) {
    const result = instance;

    result.counters[counter].length = 0;

    [...Object.values(result.roomStore)].forEach(item => {
        result.counters[counter].length += item[counter].get();
    });

    return result.counters[counter].length;
}

/**
 * initCounter: initialize a counter(adults, children...)
 * @param {Object} instance instace of the panel
 * @param {String} roomId id of a room (room-1...)
 * @param {Object} counter counter info {type:('adults' || 'children' ), selector, max, min, value}
 * @returns {Object} Instance of a CounterClient
 */
function initCounter(instance, roomId, counter) {
    const counterEl = instance.element.querySelector(counter.selector);
    const onChangeFn = `onChange-${counter.type}`.replace(/-([a-z])/g, g => g[1].toUpperCase());
    const configCounter = {
        onChange: [
            () => {
                events[onChangeFn](instance, roomId);
            }
        ],
        value: counter.value,
        max: counter.max
    };

    counterEl.dataset.max = counter.max;
    counterEl.dataset.default = counter.value;

    return Object.create(CounterClient(counter.selector, configCounter));
}

/**
 * initChildrenAge: initialize the "selects" of the age of the children
 * @param {Object} instance instace of the panel
 * @param {String} roomId id of a room (room-1...)
 * @returns {Array} an array of instance of the children age
 */
function initChildrenAge(instance, roomId) {
    const selector = config().getSelectorById(instance, 'childrenAge', roomId);
    const type = config().childrenAge.type || false;
    const selects = document.querySelectorAll(selector);
    const childrenAge = [];

    selects.forEach((item, i) => {
        const id = `[data-id="${type}-${i}"]`;
        const configSelect = {
            enableClick: true,
            choices: {
                searchEnabled: true,
                searchPlaceholderValue: '',
                loadingText: 'Cargando...',
                noResultsText: 'No se han encontrado resultados',
                noChoicesText: 'No hay opciones para selecionar',
                itemSelectText: 'Tocar para seleccionar',
                addItemText: ''
            },
            onChange: [
                () => {
                    events.onChangeAges(instance, roomId);
                }
            ]
        };

        // init select children age
        childrenAge.push(SelectClient(`${selector}${id}`, configSelect));
    });

    return childrenAge;
}

/**
 * updateCounter: recalculate all parameters of the all counters of each room
 * @param {Object} instance instace of the panel
 * @param {String} roomId id of a room (room-1...)
 * @param {String} counter the name of counter (adults, children)
 * @returns void
 */
function updateCounter(instance, roomId, counter) {
    const result = instance;
    const rooms = [...Object.values(result.roomStore)].filter(item => roomId !== item.roomID);

    calculateCounterLength(result, counter);

    rooms.forEach(item => {
        const room = item;
        const valueCounter = item[counter].value;
        const selectorFn = `selector-${counter}`.replace(/-([a-z])/g, g => g[1].toUpperCase());

        item[counter].removeEventListener();
        delete room[counter];

        room[counter] = Object.create(
            initCounter(result, item.roomID, {
                type: counter,
                selector: config().room[selectorFn](instance, item.roomID),
                value: valueCounter,
                max: result.counters[counter].max - result.counters[counter].length + valueCounter
            })
        );
    });
}

/**
 * addRoom: add an new room
 * @param {Object} instance instace of the panel
 * @returns void
 */
function addRoom(instance) {
    const result = instance;
    const maxRooms = instance.element.dataset.maxRooms || 0;
    const futureAdults = instance.counters.adults.length + instance.counters.adults.min;
    const futureChildren = instance.counters.children.length + instance.counters.children.min;

    if (
        instance.rooms.length + 1 <= maxRooms &&
        futureAdults <= instance.counters.adults.max &&
        futureChildren <= instance.counters.children.max
    ) {
        // update number of rooms selected
        result.rooms.length++;
        result.rooms.totalOpens++;

        const clonedRoom = instance.rooms.default.cloneNode(true);
        const clonedRoomId = `room-${instance.rooms.totalOpens}`;

        // Update currents adults
        result.counters.adults.length = futureAdults;

        // update currents children
        result.counters.children.length = futureChildren;

        // Prepare new room
        addRoomPrepare(instance, clonedRoom, clonedRoomId);

        // Show delete btn rooms to the first room only when we have two rooms
        addRoomHandleDeleteBtn(instance);

        // Append new room
        result.rooms.parent.appendChild(clonedRoom);

        // Config room: init elements and set events
        addRoomConfig(instance, clonedRoom, clonedRoomId);
    }
}

function addRoomPrepare(instance, clonedRoom, clonedRoomId) {
    const clonedRoomRef = clonedRoom;
    const clonedRoomTitle = clonedRoom.querySelector(config().roomTitle.selector);
    const counterAdultEl = clonedRoom.querySelector(config().adults.selector);

    clonedRoomTitle.innerHTML = `${instance.literals.room} ${instance.rooms.length}`;
    counterAdultEl.dataset.default = instance.counters.adults.min;
    clonedRoomRef.dataset.id = clonedRoomId;
}

function addRoomHandleDeleteBtn(instance) {
    const rooms = [...Object.values(instance.roomStore)];
    const firstRoom = rooms[0].element;
    const deleteBtn = firstRoom.querySelector(config().removeRoom.selector);

    if (instance.rooms.length === 2) {
        setVisible(deleteBtn);
    }
}

function addRoomConfig(instance, clonedRoom, clonedRoomId) {
    configRoom(instance, clonedRoom);

    updateCounter(instance, clonedRoomId, 'adults');
    updateCounter(instance, clonedRoomId, 'children');

    set(instance);
}

const hasRoomsToRemove = instance => instance.rooms.length - 1 >= 1;
const isSingleRoom = instance => instance.rooms.length === 1;

/**
 * removeRoom: remove the selected room
 * @param {Object} instance instace of the panel
 * @param {HTMLElement} room
 * @param {String} roomId id of a room (room-1...)
 * @returns void
 */
function removeRoom(instance, room, roomId) {
    const result = instance;

    if (!hasRoomsToRemove(instance)) {
        return;
    }

    /* Single Room */
    removeRoomHandleSingleRoom(instance);

    /* Adults */
    removeRoomHandleAdults(instance, roomId);

    /* Children */
    removeRoomHandleChildren(instance, roomId);

    /* Ages */
    removeRoomHandleAges(instance, roomId);

    /* Events */
    removeRoomHandleEvents(instance, room, roomId);

    // update title of room
    [...Object.values(instance.roomStore)].forEach((item, i) => {
        const titleRoom = item.element.querySelector(config().roomTitle.selector);
        titleRoom.innerHTML = `${instance.literals.room} ${i + 1}`;
    });

    // remove child from doom
    room.parentNode.removeChild(room);

    // remove room from roomStore
    delete result.roomStore[roomId];
    result.rooms.length--;

    // Set info on input trigger
    set(instance);
}

function removeRoomHandleSingleRoom(instance) {
    if (!isSingleRoom(instance)) {
        return;
    }

    const firstRoom = [...Object.values(instance.roomStore)][0];
    const removeBtnFirstRoom = firstRoom.element.querySelector(config().getSelector('removeRoom'));

    setHide(removeBtnFirstRoom);
}

function removeRoomHandleAdults(instance, roomId) {
    const { counters } = instance;
    const { adults } = instance.roomStore[roomId];

    adults.removeEventListener();

    counters.adults.length -= adults.get();

    updateCounter(instance, roomId, 'adults');
}

function removeRoomHandleChildren(instance, roomId) {
    const { counters } = instance;
    const { children } = instance.roomStore[roomId];

    children.removeEventListener();

    counters.children.length -= children.get();

    updateCounter(instance, roomId, 'children');
}

function removeRoomHandleAges(instance, roomId) {
    const { ages } = instance.roomStore[roomId];

    ages.forEach(item => item.removeEventListener());
}

function removeRoomHandleEvents(instance, room, roomId) {
    const { events: eventsRef } = instance.roomStore[roomId];

    const removeBtn = room.querySelector(config().getSelector('removeRoom'));

    eventsRef.removeEventListener(removeBtn);
}

const hasMultipleRooms = instance => instance.rooms.length > 1;

/**
 * configRoom: configure all element of a room:
 * counters, age of the children and her events
 * @param {Object} instance instace of the panel
 * @param {HTMLElement} room HTMLElement room
 * @returns void
 */
function configRoom(instance, room) {
    const result = instance;
    const roomId = room.dataset.id;

    result.adultsConfig = {
        type: 'adults',
        selector: config().room.selectorAdults(instance, roomId)
    };

    result.childrenConfig = {
        type: 'children',
        selector: config().room.selectorChildren(instance, roomId)
    };

    // config counters: save the current config of the counters on adultsConfig and childrenConfig
    if (hasMultipleRooms(instance)) {
        configRoomsMultiple(instance);
    } else {
        configRoomsSingle(instance);
    }

    // init selects age of children
    const ages = {
        ages: initChildrenAge(instance, roomId),
        current: 0
    };

    // init counters: adults and children
    const counters = {
        adults: initCounter(instance, roomId, instance.adultsConfig),
        children: initCounter(instance, roomId, instance.childrenConfig)
    };

    // add events
    const eventsRoom = Object.create(events);
    eventsRoom.addEventListener(instance, room);

    // store elements of a room, counters and ages
    result.roomStore[roomId] = {
        element: room,
        roomID: roomId,
        events: eventsRoom,
        codeHash: {},
        ...counters,
        ...ages
    };

    setCodeHash(instance, 'adults');
    setCodeHash(instance, 'children');
}

function configRoomsSingle(instance) {
    const { adultsConfig, childrenConfig } = instance;

    // the first room
    const adultsEl = instance.element.querySelector(config().getSelector('adults'));
    const childrenEl = instance.element.querySelector(config().getSelector('children'));

    // save the base config of a counters on instance
    setCounter(instance, adultsEl, 'adults');
    setCounter(instance, childrenEl, 'children');

    adultsConfig.max = instance.counters.adults.max;
    adultsConfig.value = instance.counters.adults.value;

    childrenConfig.max = instance.counters.children.max;
    childrenConfig.value = instance.counters.children.value;
}

function configRoomsMultiple(instance) {
    const { adultsConfig, childrenConfig } = instance;
    const { adults, children } = instance.counters;

    // the rest of the rooms
    adultsConfig.max = adults.max - adults.length + adults.min;
    adultsConfig.value = adults.min;

    childrenConfig.max = children.max - children.length + children.min;
    childrenConfig.value = children.min;
}

/**
 * initRooms: export function: initialize all elements of a room (counters, age of children and the events)
 * @param {Object} instance instace of the panel
 * @returns void
 */
function initRooms(instance) {
    const result = instance;
    const defaultRoom = instance.element.querySelector(`${config().getSelectorId('room')}`);
    const addRoomBtn = instance.config.triggerAddRoom;

    // Rooms store
    result.roomStore = {};

    // info rooms
    result.rooms = {
        default: defaultRoom.cloneNode(true),
        parent: instance.element.querySelector(config().rooms.selector),
        totalOpens: 1,
        length: 1
    };

    // info counters
    result.counters = {
        adults: {
            length: 0
        },
        children: {
            length: 0
        }
    };

    // show delete room button to the clone room
    setVisible(instance.rooms.default.querySelector(config().removeRoom.selector));

    // config first room: init elements and set events
    configRoom(instance, defaultRoom);

    // set current number of adults
    result.counters.adults.length = instance.counters.adults.value;

    // set current number of children
    result.counters.children.length = instance.counters.children.value;

    addPrivateMethods(instance);

    // Triggers to add a new room
    if (addRoomBtn) {
        addRoomBtn.forEach(trigger => {
            trigger.addEventListener('click', () => {
                addRoom(result);
            });
        });
    }

    // Set info on input trigger
    set(instance);
}

function addPrivateMethods(instance) {
    const ref = instance;

    // privated method get
    ref.getRoom = () => get(instance);

    // privated metod getHashRoom
    ref.getHashRoom = () => getHashRooms(instance);

    // privated method addRoom
    ref.addRoom = () => addRoom(instance);
}

module.exports = {
    initRooms
};
